import { forwardRef, useImperativeHandle, useRef } from 'react'
import { useNavigate } from 'react-router-dom'

import { Link, NotificationDialog, Stack, Text } from '../../../components'
import * as CreditCard from '../../../components/payment/credit-card'
import { mutations, queries } from '../../../graphql'
import { calculateGiftAmount } from '../gift-details-math'

export const PaymentUI = forwardRef(({ register, setValue, watch, fundId }, ref) => {
  const cardApi = useRef()

  useImperativeHandle(ref, () => ({
    getPaymentMethodId: async (values) => {
      if (cardApi.current.isNewCard) {
        try {
          const isRecurring = values.stepperState?.giftDetails?.isRecurring
          const multiUse = isRecurring ? true : values.multiUse
          return await cardApi.current.postToStripeAndSavePaymentMethod({ multiUse, fundId: values.fundId ?? fundId })
        } catch (e) {
          throw new Error(`This card cannot be used to finalize the transaction: ${e.message || e.type}`)
        }
      }

      return values.paymentMethodId
    },
  }))

  return (
    <Stack spacing={2}>
      <CreditCard.Select ref={cardApi} fundId={fundId} register={register} setValue={setValue} watch={watch} />
    </Stack>
  )
})

export async function getPaymentValues({ paymentMethodApi, values }) {
  const paymentMethodId = await paymentMethodApi.current.getPaymentMethodId(values)

  return {
    ...values,
    paymentMethodId,
  }
}

export function SuccessUI({ grantAmount, donationTargetName, fundId, donationTargetId }) {
  const navigate = useNavigate()

  const handleOnClick = () => {
    navigate(`/funds/${fundId}/activity`)
  }

  return (
    <NotificationDialog
      open
      onClose={handleOnClick}
      type="success"
      title="Thank You for Your Generosity!"
      message={
        <>
          <Text.Body sx={{ mb: 2 }}>
            Your donation of <strong>${Number(grantAmount).toFixed(2)}</strong> to <strong>{donationTargetName}</strong>{' '}
            (<strong>{donationTargetId}</strong>) has been successfully processed.
          </Text.Body>
          <Text.Body>
            Together, we&apos;re making an impact, and we&apos;re so grateful for your support! You can check on the
            status of your gift at anytime from the <Link to={`/funds/${fundId}/activity`}>Activity</Link> page.
          </Text.Body>
        </>
      }
      actions={[{ label: 'Done', onClick: handleOnClick }]}
    />
  )
}
